// @ts-nocheck
import React from 'react';
import * as _ from 'lodash';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Keycloak from 'keycloak-js';
import axios from 'axios';
import * as XLSX from '@e965/xlsx';
import { saveAs } from 'file-saver';
import { string } from 'yup';
import moment from 'moment';
import SwalToast from 'components/Common/SwalToast';
import {
  DOWNLOADS_TABLE_HEADERS,
  HISTORY_SANCTIONS_TABLE_DATA,
} from '../const/TableHeaders';
import { Constants } from '../const/index';
import constants, { RATING_COLORS, ratingsConfig } from '../const/Const';
// eslint-disable-next-line no-unused-vars
import banklogo from '../assets/images/logo.png';
import solytics from '../assets/images/logo2.png';
import { store } from '../state/store/Store';
import { AppConfig } from '../config/index';

const { Regex } = Constants;

const { SEARCH_TYPES, PARTY_MAPPINGS } = Constants.CommonConst;

const readExcelFile = async (file) => {
  try {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data, { type: 'array' });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];

    if (!worksheet['!ref']) {
      SwalToast({
        title: 'No worksheets found in the Excel file',
        icon: 'error',
      });
      return;
    }

    const rows = XLSX.utils.sheet_to_json(worksheet, {
      header: 1,
      raw: false,
      defval: '',
    });

    return rows;
  } catch {
    SwalToast({
      title: 'Failed to parse Excel file',
      icon: 'error',
    });
  }
};

/**
 * @function safeJoin
 * @description Safely joins array values with a delimiter, returns the value as-is if not an array
 * @param {any} val - The value to join (array or other)
 * @param {string} delimiter - The delimiter to use for joining (default: ', ')
 * @returns {string} The joined string or original value
 * @example
 * safeJoin(['a', 'b', 'c']) // returns "a, b, c"
 * safeJoin(['a', 'b', 'c'], '|') // returns "a|b|c"
 * safeJoin('not an array') // returns "not an array"
 */
export const safeJoin = (val, delimiter = ', ') => {
  if (Array.isArray(val)) {
    return val.join(delimiter);
  }
  return val;
};

/**
 * @function lastElement
 * Returns the last element of an array.
 * @param {array} arr - The input array.
 * @returns The last element, or `undefined` if the array is empty or invalid.
 */
const lastElement = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return undefined;
  return arr[arr.length - 1];
};

export const pdfDownloadHandler = (name, div, user, organisation) => {
  const input = document.getElementById(div);
  const clientHeight = input.clientHeight + 50;
  const { clientWidth } = input;
  // Logging intentionally for debugging
  html2canvas(input).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    // eslint-disable-next-line new-cap
    const pdf = new jsPDF('p', 'px', [clientWidth, clientHeight]);
    const imgProps = pdf.getImageProperties(imgData);
    const width = pdf.internal.pageSize.getWidth();
    const height = (imgProps.height * width) / imgProps.width;

    function loadImage(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.src = url;
      });
    }

    pdf.addImage(imgData, 'PNG', 0, 40, width, height);
    pdf.text(
      `Reviewed By Analyst : ${user} on ${new Date().toLocaleString()}`,
      width - 350,
      35
    );
    pdf.setFontSize(35);
    pdf.text(`${organisation.name}`, 15, 35);
    pdf.setFontSize(16);
    pdf.text('Powered By ', width - 65 - width / 2, height + 30);
    loadImage(solytics).then((logo1) => {
      pdf.addImage(logo1, 'png', width - width / 2, height + 15, 90, 25);
      pdf.save(`${name}.pdf`);
    }); // Format is like this => X-Y-width-height for image only

    // loadImage(banklogo).then((logo) => {
    //   pdf.addImage(logo, 'png', 15, 15, width * 0.2, width * 0.05);
    // });
  });
};
const getDetailType = (row, screen) => {
  // For transaction screen, determine either to fetch payer or recipient
  if (screen === 'transaction_screen') {
    if (row?.payer) {
      return 'payer_details';
    }
    if (row?.recipient) {
      return 'recipient_details';
    }
  }
  return null;
};

const getRowEntitySearchId = (row) => {
  if (!row || typeof row !== 'object') return null;
  if (row?.search_id) return row.search_id;

  const cardKey = Object.keys(row).find(
    (key) => key.startsWith('card_') && row[key]
  );
  return cardKey ? cardKey.replace(/^card_/, '') : null;
};

const extractTransferResultArray = (
  resultSource,
  resultType,
  searchId = null
) => {
  if (!resultSource || typeof resultSource !== 'object') return [];

  // Try search_id-specific lookup first
  if (searchId && resultSource[searchId]?.[resultType]) {
    const bucket = resultSource[searchId][resultType];
    if (Array.isArray(bucket)) return bucket;
  }

  // Try direct result type lookup
  if (Array.isArray(resultSource[resultType])) {
    return resultSource[resultType];
  }

  // Generic fallback: find any array matching resultType across all nested objects
  return Object.values(resultSource)
    .map((val) => val?.[resultType])
    .filter((arr) => Array.isArray(arr))
    .flat();
};

const mapTransferMatches = (
  dataToSearch,
  transferObj,
  currentRowId,
  currentSearchId
) =>
  dataToSearch
    .filter(
      (transferData) =>
        transferData?.id === currentRowId ||
        (currentSearchId && transferData?.search_id === currentSearchId)
    )
    .map((match) => ({
      ...match,
      ...transferObj,
      results: undefined,
    }));

const getJsonDownloadUrl = (jsonData) => {
  const output = JSON.stringify({ jsonData }, null, 4);
  const blob = new Blob([output]);
  const downloadUrl = URL.createObjectURL(blob);
  return downloadUrl;
};

const downloadFile = (link, fileName) => {
  const dlink = document.createElement('a');
  dlink.download = fileName;
  dlink.href = link;
  dlink.onclick = () => {
    // revokeObjectURL needs a delay to work properly
    const that = this;
    setTimeout(() => {
      window.URL.revokeObjectURL(that.href);
    }, 1500);
  };

  dlink.click();
  dlink.remove();
};

const summaryTableDataMapper = (searchType, tableData) => {
  const tableIndividual = tableData.map((item) => {
    return {
      'Header Name': 'Personal Information',
      'Full Name': item.name,
      Alias: Array.isArray(item.alias_name)
        ? `${item.alias_name.join().slice(0, 150)}...`
        : 'N/A',
      Address: item.matched_address,
      Gender: item.gender,
    };
  });
  return tableIndividual;
};
// converting hierarchical structure to flat
const prepareCsvDataOfDownloads = (downloads, type) => {
  let dataToReturn = [];
  if (downloads?.length) {
    let rootLevelColumns = DOWNLOADS_TABLE_HEADERS.ROOT_LEVEL;
    switch (type) {
      case 'individual':
        rootLevelColumns = [
          ...rootLevelColumns,
          ...DOWNLOADS_TABLE_HEADERS.INDIVIDUAL_ADDITIONAL_INFO,
        ];
        break;
      case 'entity':
        rootLevelColumns = [
          ...rootLevelColumns,
          ...DOWNLOADS_TABLE_HEADERS.ENTITY_ADDITIONAL_INFO,
        ];
        break;
      case 'vessel':
        rootLevelColumns = [
          ...rootLevelColumns,
          ...DOWNLOADS_TABLE_HEADERS.VESSEL_ADDITIONAL_INFO,
        ];
        break;
      case 'aircraft':
        rootLevelColumns = [
          ...rootLevelColumns,
          ...DOWNLOADS_TABLE_HEADERS.AIRCRAFT_ADDITIONAL_INFO,
        ];
        break;
      default:
    }
    // eslint-disable-next-line no-use-before-define
    const columnNames = createColumnNamesRow(
      rootLevelColumns,
      DOWNLOADS_TABLE_HEADERS.SL,
      DOWNLOADS_TABLE_HEADERS.AMS,
      DOWNLOADS_TABLE_HEADERS.PEP,
      DOWNLOADS_TABLE_HEADERS.LEGAL,
      DOWNLOADS_TABLE_HEADERS.CORPORATE_DETAILS,
      DOWNLOADS_TABLE_HEADERS.CHARGES,
      DOWNLOADS_TABLE_HEADERS.SIGNATORIES,
      downloads
    );
    if (columnNames?.length) {
      dataToReturn.push(columnNames);
    }

    downloads?.forEach((row) => {
      const maxSize = _.max([
        row?.AMS?.length,
        row?.PEP?.length,
        row?.Sanctions?.length,
        row?.Legal?.length,
        row?.Corporate?.masterData?.length,
        row?.Corporate?.charges?.length,
        row?.Corporate?.directors_history?.length,
      ]);
      dataToReturn = [
        ...dataToReturn,
        // eslint-disable-next-line no-use-before-define
        ...createRowData(
          row,
          rootLevelColumns,
          maxSize || 1,
          DOWNLOADS_TABLE_HEADERS.SL,
          DOWNLOADS_TABLE_HEADERS.AMS,
          DOWNLOADS_TABLE_HEADERS.PEP,
          DOWNLOADS_TABLE_HEADERS.LEGAL,
          DOWNLOADS_TABLE_HEADERS.CORPORATE_DETAILS,
          DOWNLOADS_TABLE_HEADERS.CHARGES,
          DOWNLOADS_TABLE_HEADERS.SIGNATORIES
        ),
      ];
    });
  }

  return dataToReturn;
};

const autoScroll = (id) => {
  setTimeout(() => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      element.focus({ preventScroll: true });
    } else {
      window.scrollTo({
        behavior: 'smooth',
        top:
          document.body.scrollHeight || document.documentElement.scrollHeight,
      });
    }
  }, 200);
};
const autoScrollToComponent = (myComponentRef) => {
  if (myComponentRef.current) {
    setTimeout(() => {
      myComponentRef.current.scrollIntoView({
        behavior: 'smooth',
      });
    }, 50);
  }
};

const getDedupeTypeKey = (searchType) => {
  switch (searchType) {
    case SEARCH_TYPES.i.key:
      return 'individual';
    case SEARCH_TYPES.e.key:
      return 'entity';
    case SEARCH_TYPES.a.key:
      return 'aircraft';
    case SEARCH_TYPES.v.key:
      return 'vessel';
    default:
      return 'individual';
  }
};

const downloadExcelFile = (label) => {
  // Define data for the Excel file
  const data = [
    [label], // Header row based on the label
    [], // Add rows here if needed
  ];

  // Create a worksheet
  const worksheet = XLSX.utils.aoa_to_sheet(data);

  // Create a workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  // Generate file name based on the label
  const fileName = `${label.replace(/\s+/g, '_')}_sample.xlsx`;

  // Trigger the download
  XLSX.writeFile(workbook, fileName);
};

const createRowData = (
  row,
  columns,
  iterationLength,
  slColumns,
  amsColumns,
  pepColumns,
  LegalColumns,
  CorporateColumns,
  ChargesColumns,
  DirectorColumns
) => {
  const arr = [];

  for (let i = 0; i < iterationLength; i = +1) {
    const newRow = [];
    // level zero
    columns.forEach((col) => {
      newRow.push(col.dataExtractor(row));
    });

    // sl
    if (slColumns?.length && row?.Sanctions?.length)
      slColumns.forEach((col) => {
        newRow.push(
          row.Sanctions?.[i] ? col.dataExtractor(row.Sanctions[i]) : ''
        );
      });

    // ams
    if (amsColumns?.length && row?.AMS?.length)
      amsColumns.forEach((col) => {
        newRow.push(row.AMS?.[i] ? col.dataExtractor(row.AMS[i]) : '');
      });

    // pep
    if (pepColumns?.length && row?.PEP?.length)
      pepColumns.forEach((col) => {
        newRow.push(row.PEP?.[i] ? col.dataExtractor(row.PEP[i]) : '');
      });

    // Legal
    if (LegalColumns?.length && row?.Legal?.length)
      LegalColumns.forEach((col) => {
        newRow.push(row.Legal?.[i] ? col.dataExtractor(row.Legal[i]) : '');
      });

    // Corprate MasterData
    if (CorporateColumns?.length && row?.Corporate?.masterData?.length)
      CorporateColumns.forEach((col) => {
        newRow.push(
          row?.Corporate?.masterData?.[i]
            ? col.dataExtractor(row?.Corporate?.masterData[i])
            : ''
        );
      });
    // Corprate Charges
    if (ChargesColumns?.length && row?.Corporate?.charges?.length)
      ChargesColumns.forEach((col) => {
        newRow.push(
          row?.Corporate?.charges?.[i]
            ? col.dataExtractor(row?.Corporate?.charges[i])
            : ''
        );
      });
    // Corprate Director
    if (DirectorColumns?.length && row?.Corporate?.directors_history?.length)
      DirectorColumns.forEach((col) => {
        newRow.push(
          row?.Corporate?.directors_history?.[i]
            ? col.dataExtractor(row?.Corporate?.directors_history[i])
            : ''
        );
      });

    arr.push(newRow);
  }

  return arr;
};

const createColumnNamesRow = (
  rootLevelColumns,
  SL,
  AMS,
  PEP,
  LEGAL,
  CORPORATE_DETAILS,
  CHARGES,
  SIGNATORIES,
  downloads
) => {
  const columnsRow = [];
  let containsSl = false;
  let containsAms = false;
  let containsPep = false;
  let containsLegal = false;
  let containsCorporate = false;
  let containsCharges = false;
  let containsDirector = false;

  rootLevelColumns.forEach((col) => {
    columnsRow.push(col.label);
  });

  // checking if any of row contain SL, AMS, PEP, Legal, Corporate
  downloads?.forEach((row) => {
    if (!containsSl) {
      containsSl = Boolean(row?.Sanctions?.length);
    }
    if (!containsAms) {
      containsAms = Boolean(row?.AMS?.length);
    }
    if (!containsPep) {
      containsPep = Boolean(row?.PEP?.length);
    }
    if (!containsLegal) {
      containsLegal = Boolean(row?.Legal?.length);
    }
    if (!containsCorporate) {
      containsCorporate = Boolean(row?.Corporate?.masterData?.length);
    }
    if (!containsCharges) {
      containsCharges = Boolean(row?.Corporate?.charges?.length);
    }
    if (!containsDirector) {
      containsDirector = Boolean(row?.Corporate?.directors_history?.length);
    }
  });

  // if row contains  SL, AMS, PEP, Legal, Corporate then add entry to headings.
  // SL, AMS, PEP sequence matters
  if (containsSl) {
    SL.forEach((col) => {
      columnsRow.push(col.label);
    });
  }
  if (containsAms) {
    AMS.forEach((col) => {
      columnsRow.push(col.label);
    });
  }
  if (containsPep) {
    PEP.forEach((col) => {
      columnsRow.push(col.label);
    });
  }
  if (containsLegal) {
    LEGAL.forEach((col) => {
      columnsRow.push(col.label);
    });
  }
  if (containsCorporate) {
    CORPORATE_DETAILS.forEach((col) => {
      columnsRow.push(col.label);
    });
  }
  if (containsCharges) {
    CHARGES.forEach((col) => {
      columnsRow.push(col.label);
    });
  }
  if (containsDirector) {
    SIGNATORIES.forEach((col) => {
      columnsRow.push(col.label);
    });
  }
  return columnsRow;
};

const validateFileColumns = (fileColumns, columns) => {
  if (fileColumns.length !== columns.length) return false;
  for (let i = 0; i < columns.length; i += 1) {
    if (fileColumns[i] !== columns[i]) return false;
  }
  return true;
};
/**
 * @function validateInitiateFileColumns
 * @description a function to show validated initiated file columns with dynamic Field support (Field 1 to Field 20)
 * @param {array} fileColumns - file columns
 * @param {array} requiredColumns - uploaded file columns
 * @param {bool} permission - file permission
 * @returns {bool}
 */
const validateInitiateFileColumns = (fileColumns, requiredColumns) => {
  const expectedColumns = [...requiredColumns];

  const fieldStartIndex = expectedColumns.findIndex((col) =>
    /^Field [1-9][0-9]*$/.test(col)
  );

  if (fieldStartIndex === -1) {
    if (fileColumns.length !== requiredColumns.length) return false;

    for (let i = 0; i < requiredColumns.length; i += 1) {
      if (fileColumns[i] !== requiredColumns[i]) return false;
    }
    return true;
  }

  const baseColumns = expectedColumns.filter(
    (col) => !/^Field [1-9][0-9]*$/.test(col)
  );

  const fileFieldColumns = fileColumns.filter((col) =>
    /^Field [1-9][0-9]*$/.test(col)
  );

  if (fileFieldColumns.length > 0) {
    const fieldNumbers = fileFieldColumns
      .map((col) => parseInt(col.replace('Field ', ''), 10))
      .filter((num) => !Number.isNaN(num));

    for (let i = 0; i < fieldNumbers.length; i += 1) {
      if (fieldNumbers[i] < 1 || fieldNumbers[i] > 20) {
        return false;
      }
    }

    const uniqueFieldNumbers = [...new Set(fieldNumbers)];
    if (uniqueFieldNumbers.length !== fieldNumbers.length) {
      return false;
    }
  }

  const baseFileColumns = fileColumns.filter(
    (col) => !/^Field [1-9][0-9]*$/.test(col)
  );

  if (baseFileColumns.length !== baseColumns.length) return false;

  for (let i = 0; i < baseColumns.length; i += 1) {
    if (baseFileColumns[i] !== baseColumns[i]) return false;
  }

  return true;
};

/**
 * @function alertListType
 * @description a function to show alert list type
 * @param {object} cardData
 * @returns {array}
 */
const alertListType = (cardData) => {
  const output = [];
  if (
    cardData?.sanction_count ||
    cardData?.sanction_country_count ||
    cardData?.mnrl_count
  )
    output.push('Sanctions');
  if (cardData?.pep_count) output.push('PEP');
  if (cardData?.ams_count) output.push('AMS');
  if (cardData?.risk_rating_alert) output.push('RISK');
  if (cardData?.legal_count) output.push('Legal');
  if (cardData?.corporate_count) output.push('Corporate');
  if (!cardData?.is_transaction_excluded && output.length === 0)
    return 'No Alert';
  return cardData?.is_transaction_excluded
    ? 'NA-Existing Customer'
    : output.join(', ');
};

/**
 * @function getAlertListTypesForTable
 * @description Get alert list types based on count fields in row data for table
 * @param {Object} rowData - The row data object containing alert counts
 * @returns {string} Comma-separated alert types or 'N/A'
 */
const getAlertListTypesForTable = (rowData) => {
  if (!rowData) return 'N/A';

  const alertTypes = [];

  const sanctionCount =
    (rowData?.sanction_country_count || 0) +
    (rowData?.sanction_count || 0) +
    (rowData?.mnrl_count || 0);
  if (sanctionCount > 0) alertTypes.push('Sanction');

  if ((rowData?.pep_count || 0) > 0) alertTypes.push('PEP');

  if ((rowData?.ams_count || 0) > 0) alertTypes.push('AMS');

  if (rowData?.risk_rating_alert) alertTypes.push('RISK');

  if ((rowData?.legal_count || 0) > 0) alertTypes.push('Legal');

  if ((rowData?.corporate_count || 0) > 0) alertTypes.push('Corporate');

  return alertTypes.length > 0 ? alertTypes.join(', ') : 'N/A';
};

/**
 * @function getAlertListTypesForTransactionDetails
 * @description Get alert list types for transaction screening (payer_details or recipient_details)
 * @param {Object} detailsData - The payer_details or recipient_details object
 * @returns {string} Comma-separated alert types or 'N/A'
 */
const getAlertListTypesForTransactionDetails = (detailsData) => {
  if (!detailsData) return 'N/A';
  if (detailsData?.is_transaction_excluded) return 'N/A';

  const alertTypes = [];

  if (detailsData?.sanction_alert || detailsData?.sanction_country_alert) {
    alertTypes.push('Sanction');
  }
  if (detailsData?.pep_alert) alertTypes.push('PEP');
  if (detailsData?.ams_alert) alertTypes.push('AMS');
  if (detailsData?.risk_rating_alert) alertTypes.push('RISK');
  if (detailsData?.legal_alert) alertTypes.push('Legal');
  if (detailsData?.corporate_alert) alertTypes.push('Corporate');

  return alertTypes.length > 0 ? alertTypes.join(', ') : 'N/A';
};

/**
 * @function mergeArrays
 * @description a function to merge arrays
 * @param {object} arr1 - first array
 * @param {object} arr2 - second array
 * @returns {array}
 */
const mergeArrays = (arr1, arr2) => {
  // Ensure arr1 and arr2 are valid arrays, defaulting to empty arrays if not
  const safeArr1 = Array.isArray(arr1) ? arr1 : [];
  const safeArr2 = Array.isArray(arr2) ? arr2 : [];

  const updatedArr1 = safeArr1.map((item) => ({
    ...item,
    payer: true,
  }));

  const updatedArr2 = safeArr2.map((item) => ({
    ...item,
    recipient: true,
  }));

  return [...updatedArr1, ...updatedArr2];
};

/**
 * @function alertBySanctions
 * @description shows the type of alert(Sanctions, PEP,AMS)
 * @param {object} cardData card containing data of searched user
 * @returns {array}
 */
const alertBySanctions = (cardData) => {
  const output = [];
  if (cardData?.sanction_alert) output.push('Sanctions');
  if (cardData?.pep_alert) output.push('PEP');
  if (cardData?.ams_alert) output.push('AMS');
  if (cardData?.risk_rating_alert) output.push('RISK');
  if (cardData?.legal_alert) output.push('Legal');
  if (cardData?.corporate_alert) output.push('Corporate');
  if (output.length === 0) return 'N/A ';
  return output.join(', ');
};
const initKeycloak = async () => {
  const { REALM_ID, token, refresh, idToken } = store.getState().app.auth;

  const initOptions = {
    url: AppConfig.keycloakUrl,
    realm: REALM_ID,
    clientId: 'frontend',
    onLoad: 'check-sso', // check-sso | login-required
    KeycloakResponseType: 'code',
  };

  const keycloakConfig = new Keycloak(initOptions);
  window.KEYCLOAK_CONFIG = keycloakConfig;
  return keycloakConfig
    .init({
      onLoad: 'login-required',
      KeycloakResponseType: 'code',
      checkLoginIframe: false,
      pkceMethod: 'S256',
      ...(token && refresh ? { token, refreshToken: refresh, idToken } : {}),
    })
    .then((auth) => {
      if (!auth) {
        window.location.reload();
      } else {
        store.dispatch({
          type: 'app/setAuth',
          payload: { ...auth },
        });
        document.dispatchEvent(
          new CustomEvent('KEYCLOAK_LOGIN_SUCCESS', {
            detail: { auth, keycloakConfig },
          })
        );
      }
      return auth;
    });
};
const isValueEmpty = (value) => {
  switch (true) {
    case value === undefined:
    case value === null:
      return true;
    case typeof value === 'object':
      return !Object.keys(value).length;
    case typeof value === 'string':
      return !value.trim().length;
    default:
      return false;
  }
};

const getErrorHelperText = (error, touched) => {
  return touched ? error : null;
};

export const castNumeric = (v) =>
  typeof v === 'string' && v.trim() !== '' && !Number.isNaN(Number(v))
    ? Number(v)
    : v;

/**
 * Coerces a party field's value based on its schema-declared field_type
 * (currently: numeric fields are cast to numbers). Used when building
 * involved-party payloads from dynamically fetched party schemas.
 */
export const castFieldValueByType = (schemaFields, backendName, value) => {
  const fieldSchema = schemaFields?.find(
    (field) => field.backend_name === backendName
  );
  return fieldSchema?.field_type === 'number' ? castNumeric(value) : value;
};

const customAxiosForFastApi = axios.create({
  baseURL: AppConfig.fastApiBaseUrl, // Custom baseURL
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Add a request interceptor
customAxiosForFastApi.interceptors.request.use(
  (config) => {
    const { token, org } = store.getState().app.auth;

    const updatedConfig = {
      ...config,
      headers: {
        ...config.headers,
        ...(token && { HTTPBearer: `Bearer ${token}` }),
        ...(org && { org }),
      },
    };

    return updatedConfig;
  },
  (error) => {
    return Promise.reject(error);
  }
);
const capitalizeFirstLetter = (str) => {
  if (!str) return '';
  return str?.charAt(0)?.toUpperCase() + str?.slice(1);
};
function capitalizeFirstLetterOfWords(str) {
  return str
    ?.split(' ') // Split the string into an array of words
    ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
    ?.join(' '); // Join the words back into a single string
}

const downloadBulkInitiateExcelFile = (
  headers,
  fileName = 'empty_file.xlsx',
  screening = null
) => {
  if (!Array?.isArray(headers) || headers?.length === 0) {
    return;
  }

  // Step 1: Create a worksheet with headers as the first row
  let worksheetData = [];
  if (screening === 'transaction') {
    const typeIndex = headers?.indexOf('Type');
    if (typeIndex === -1) {
      return;
    }

    // Step 1: Create a worksheet with headers + Payer + Recipient
    worksheetData = [
      headers,
      Array(headers?.length)
        ?.fill('')
        ?.map((__, idx) => (idx === typeIndex ? 'Payer' : '')),
      Array(headers?.length)
        ?.fill('')
        ?.map((__, idx) => (idx === typeIndex ? 'Recipient' : '')),
    ];
  } else {
    worksheetData = [headers]; // The first row of the sheet will be the headers
  }

  // Step 2: Create a worksheet and workbook
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData); // Convert 2D array to worksheet
  const workbook = XLSX.utils.book_new(); // Create a new workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1'); // Add worksheet to workbook

  // Step 3: Write the workbook and trigger a download
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

  // Step 4: Save the file using FileSaver
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, fileName);
};

const sortOptions = (arr) => {
  return arr?.sort((a, b) =>
    a?.username?.toLowerCase().localeCompare(b?.username?.toLowerCase())
  );
};

/**
 * @function sortSelectedFirst
 * @description Returns a new array with items whose value is currently selected moved to the
 * top of the list, preserving the relative order within the selected and unselected groups.
 * Used by multi-select components/modals so selected options stay visible above the rest.
 * @param {Array} items - list of options (objects or primitives) to reorder
 * @param {Array} selectedValues - values that are currently selected
 * @param {(item: any) => any} getValue - extracts the comparable value from an item (default: identity)
 * @returns {Array} new array with selected items first
 * @example sortSelectedFirst([{ value: 'a' }, { value: 'b' }], ['b'], (o) => o.value)
 * // [{ value: 'b' }, { value: 'a' }]
 */
const sortSelectedFirst = (
  items,
  selectedValues,
  getValue = (item) => item
) => {
  if (!Array.isArray(items) || items.length === 0) return items || [];
  const safeSelected = Array.isArray(selectedValues) ? selectedValues : [];
  if (!safeSelected.length) return items;

  const selectedSet = new Set(safeSelected);
  const selected = [];
  const unselected = [];
  items.forEach((item) => {
    if (selectedSet.has(getValue(item))) {
      selected.push(item);
    } else {
      unselected.push(item);
    }
  });
  return [...selected, ...unselected];
};
export const joinArrayWithSeparator = (
  arr,
  sep = constants.GLOBAL_SEPARATOR
) => {
  if (!Array.isArray(arr)) return arr;
  return arr?.filter((item) => item !== '')?.join(sep);
};

export const formatDisplayValue = (value) => {
  if (
    value === null ||
    value === undefined ||
    value === '' ||
    (typeof value === 'object' && Object.keys(value).length === 0)
  )
    return 'None';

  if (typeof value === 'object' && !Array.isArray(value)) {
    const formatted = Object.entries(value)
      .filter(([_, val]) => val !== null && val !== undefined && val !== '')
      .map(([key, val]) => `${key} : ${val}`)
      .join(', ');

    return formatted || 'None';
  }

  const parts = String(value)
    .split(constants.GLOBAL_SEPARATOR)
    .map((part) => part.trim())
    .filter((part) => part !== '');

  return parts.length > 0 ? parts.join(' | ') : 'N/A';
};

const formatSnakeCaseToTitleCase = (str, separator = '_') => {
  if (!str) return '';

  return str
    ?.split(separator)
    ?.map((word) => word.charAt(0).toUpperCase() + word?.slice(1).toLowerCase())
    ?.join(' ');
};
const convertArrayParamsToString = (obj, separator = ',') => {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }

  return Object.fromEntries(
    Object.entries(obj)?.map(([key, value]) => {
      if (Array.isArray(value)) {
        return [key, value?.filter((item) => item != null)?.join(separator)];
      }
      return [key, value];
    })
  );
};

const calculatePasswordStrength = (password) => {
  if (!password) return { strength: 0, label: '' };

  const { length } = password;
  const hasUpperCase = Regex.upperCaseReg.test(password);
  const hasNumber = Regex.numbersReg.test(password);
  const hasSpecialChar = Regex.hasSpecialCharReg.test(password);

  let strength = 0;

  if (password.length >= 14) strength += 40;
  else if (length > 10) strength += 10;

  if (hasUpperCase) strength += 20;
  if (hasNumber) strength += 20;
  if (hasSpecialChar) strength += 20;

  strength = Math.min(strength, 100);

  let label;
  if (strength <= 30) {
    label = 'weak';
  } else if (strength <= 70) {
    label = 'Medium';
  } else {
    label = 'Strong';
  }

  return { strength, label };
};

const getVerdicts = (data, dashboard, detailsType) => {
  if (detailsType) {
    return dashboard
      ? data?.remarks
      : data?.payer_details?.verdicts ?? data?.recipient_details?.verdicts;
  }

  return dashboard ? data?.remarks : data?.verdicts;
};

const getReworkDataForRow = (
  data,
  dashboard,
  index,
  resultType,
  detailsType
) => {
  if (!data || index === undefined || !resultType) {
    return [];
  }
  const verdicts = getVerdicts(data, dashboard, detailsType);
  return verdicts
    ?.filter((verdict) => verdict.hasOwnProperty('rereview'))
    ?.map((verdict) => ({
      revertDetails: detailsType
        ? verdict?.results?.[detailsType]?.[resultType]?.[index]
        : verdict?.results?.[resultType]?.[index],
      revertBy: verdict.user__username,
      timestamp: verdict.timestamp,
    }));
};

const getReferralDataForRow = (
  allReferralData,
  currentRow,
  resultIn,
  resultType,
  detailsType
) => {
  if (
    !allReferralData ||
    !Array.isArray(allReferralData) ||
    allReferralData.length === 0
  ) {
    return [];
  }
  let matchingReferrals = [];
  allReferralData.forEach((referralObj) => {
    const dataObj = detailsType
      ? referralObj?.[resultIn]?.[detailsType]
      : referralObj?.[resultIn];
    if (dataObj?.[resultType] && Array.isArray(dataObj?.[resultType])) {
      let matches = dataObj?.[resultType].filter(
        (refData) => refData.id === currentRow.id
      );
      if (matches.length > 0 && referralObj.requested_to?.username) {
        matches = matches.map((match) => ({
          ...match,
          username:
            resultIn === 'data_matched'
              ? referralObj?.requested_to?.username
              : referralObj?.requested_by?.username,
          timestamp: referralObj.submitted_date ?? referralObj?.last_updated,
        }));
      }
      matchingReferrals = [...matchingReferrals, ...matches];
    }
  });
  return matchingReferrals;
};

const sortByDate = (data, time = 'timestamp') => {
  data.sort((a, b) => new Date(b[time]) - new Date(a[time]));
  return data;
};
const isReassignTransfer = (transfer) =>
  Boolean(transfer?.transfer_type?.endsWith('_assign'));

const splitTransferAndReassignData = (transferData, reassignData) => ({
  transferRows: (transferData || []).filter(
    (item) => !isReassignTransfer(item)
  ),
  reassignRows: [
    ...(reassignData || []),
    ...(transferData || []).filter(isReassignTransfer),
  ],
});
const getTransferDataForRow = (
  allTransferData,
  currentRow,
  resultType,
  detailType = null
) => {
  if (!allTransferData?.length || !currentRow || !resultType) {
    return [];
  }

  const currentSearchId = getRowEntitySearchId(currentRow);
  const currentRowId = currentRow?.id;

  const matchingTransfers = allTransferData.flatMap((transferObj) => {
    if (!transferObj?.results) return [];

    // Try detail-specific results first, fall back to general results
    const resultSource = detailType
      ? transferObj.results[detailType] || transferObj.results
      : transferObj.results;

    const dataToSearch = extractTransferResultArray(
      resultSource,
      resultType,
      currentSearchId
    );

    const matches = mapTransferMatches(
      dataToSearch,
      transferObj,
      currentRowId,
      currentSearchId
    );

    if (matches.length || !detailType || resultSource === transferObj.results) {
      return matches;
    }

    return mapTransferMatches(
      extractTransferResultArray(
        transferObj.results,
        resultType,
        currentSearchId
      ),
      transferObj,
      currentRowId,
      currentSearchId
    );
  });

  return sortByDate(matchingTransfers);
};
const formatUserDisplayName = (options) => {
  if (!options) return 'N/A';
  let fullName = options?.full_name;
  if (!fullName && (options?.user__first_name || options?.user__last_name)) {
    fullName = `${options?.user__first_name || ''} ${
      options?.user__last_name || ''
    }`.trim();
  } else if (!fullName && (options?.first_name || options?.last_name)) {
    fullName = `${options?.first_name || ''} ${
      options?.last_name || ''
    }`.trim();
  } else if (!fullName && (options?.firstName || options?.lastName)) {
    fullName = `${options?.firstName || ''} ${options?.lastName || ''}`.trim();
  }
  fullName = fullName || 'N/A';
  const userName = options?.user__username || options?.username || 'N/A';
  return `${fullName} (${userName})`;
};

const excelDateToJSDate = (date) => {
  if (date == null) return null;
  if (typeof date === 'number' && !Number.isNaN(date)) {
    if (date < 1 || date > 2958465) {
      return null;
    }
    return new Date(Math.round((date - 25569) * 86400 * 1000));
  }
  if (typeof date === 'string' && date.trim() !== '') {
    const dateObj = new Date(date);
    return !Number.isNaN(dateObj.getTime()) ? dateObj : null;
  }
  return null;
};

export const getFieldError = (form, fieldName) => {
  return form.touched[fieldName] && form.errors[fieldName]
    ? String(form.errors[fieldName])
    : '';
};

const CalculateCount = ({
  isCompletedReferrals,
  referralData,
  screen,
  data,
  type,
  sanctionsList = null,
  pepList = null,
  amsList = null,
  legalList = null,
  corporateList = null,
  // Demo Changes
  goodsList = null,
}) => {
  if (!isCompletedReferrals && referralData) {
    switch (type) {
      case 'sanctions':
        return (
          (sanctionsList?.sanction_result?.length || 0) +
          (sanctionsList?.sanction_country_result?.length || 0) +
          (sanctionsList?.mnrl_result?.length || 0)
        );
      case 'pep':
        return pepList?.length || 0;
      case 'ams':
        return amsList?.length || 0;
      case 'legal':
        return (legalList?.length || 0) + (corporateList?.length || 0);
      case 'goodsList':
        return goodsList?.length || 0;
      default:
        return 0;
    }
  }

  if (screen === 'transaction_screen') {
    const detailsFieldNames = getDetailsFieldNames(data);

    const getCountByType = (countType) => {
      if (countType === 'goodsList') return 1;
      return detailsFieldNames.reduce((total, field) => {
        if (!data?.[field]) return total;

        const fieldData = data[field];
        const itemsToProcess = Array.isArray(fieldData)
          ? fieldData
          : Object.values(fieldData);

        const fieldTotal = itemsToProcess.reduce((subTotal, item) => {
          let count = 0;

          switch (countType) {
            case 'sanctions':
              count =
                (item?.sanction_country_count || 0) +
                (item?.sanction_count || 0) +
                (item?.mnrl_count || 0);
              break;
            case 'pep':
              count = item?.pep_count || 0;
              break;
            case 'ams':
              count = item?.ams_count || 0;
              break;
            case 'legal':
              count = (item?.legal_count || 0) + (item?.corporate_count || 0);
              break;
            default:
              count = 0;
          }
          return subTotal + count;
        }, 0);

        return total + fieldTotal;
      }, 0);
    };

    return getCountByType(type);
  }

  if (!data) return 0;

  switch (type) {
    case 'sanctions':
      return (
        (data.sanction_country_count || 0) +
        (data.sanction_count || 0) +
        (data.mnrl_count || 0)
      );
    case 'pep':
      return data.pep_count || 0;
    case 'ams':
      return data.ams_count || 0;
    case 'legal':
      return (data.legal_count || 0) + (data.corporate_count || 0);
    default:
      return 0;
  }
};

const getDisplayValue = ({
  displayList,
  isCompletedReferrals,
  screen,
  data,
  tableData,
  addonActiveTab,
}) => {
  const listTypeMap = {
    sanctionList: 'sanctions',
    pepList: 'pep',
    amsList: 'ams',
    addonList: 'legal',
    goodsList: 'goodsList',
  };

  if (displayList === 'riskRating') {
    return tableData?.riskList?.length;
  }

  if (displayList === 'addonList') {
    if (addonActiveTab === 'legal') {
      return tableData?.legalList?.length;
    }
    if (addonActiveTab === 'corporate') {
      return tableData?.corporateList?.length;
    }
  }

  if (displayList in listTypeMap) {
    return CalculateCount({
      isCompletedReferrals,
      referralData: isCompletedReferrals,
      screen,
      data,
      tableData,
      type: listTypeMap[displayList],
    });
  }

  return data?.risk_rating;
};

const getCustomFieldsWithValue = (customFields) => {
  if (!customFields) return {};
  return Object.entries(customFields)
    .filter(
      ([, value]) => value !== null && value !== undefined && value !== ''
    )
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
};

const isParameterRequired = (
  searchType,
  crrMandatoryParameterList,
  parameterName,
  riskValidation
) => {
  const hasIndividual =
    crrMandatoryParameterList && crrMandatoryParameterList?.individual;
  const hasEntity =
    crrMandatoryParameterList && crrMandatoryParameterList?.entity;
  if (riskValidation) {
    return (
      (searchType === 'i' &&
        hasIndividual &&
        crrMandatoryParameterList.individual?.includes(parameterName)) ||
      (searchType === 'e' &&
        hasEntity &&
        crrMandatoryParameterList.entity?.includes(parameterName))
    );
  }
};

const generateDynamicSchema = (fields) => {
  const schema = {};
  fields?.forEach((field) => {
    if (field?.type === 'continuous') {
      schema[field.name] = string().when('search_type', {
        is: (searchType) => isParameterRequired(searchType, field.name),
        then: string()
          .matches(
            /^[0-9]+$/, // Regex for numeric validation
            `${field.name} is Invalid`
          )
          .required(`${field.name} is marked as mandatory`),
        otherwise: string().matches(/^[0-9]+$/, `${field.name} is Invalid`),
      });
    } else if (field.type === 'categorical') {
      schema[field.name] = string().when('search_type', {
        is: (searchType) => isParameterRequired(searchType, field.name),
        then: string().required(`${field.name} is marked as mandatory`),
        otherwise: string().nullable(),
      });
    }
  });
  return schema;
};

const processAddressData = (addressString) => {
  if (!addressString) return [];

  return addressString
    .split(constants.GLOBAL_SEPARATOR)
    .filter((addr) => addr.trim() !== '');
};

const restructureAddressData = (addressString) => {
  const processed = processAddressData(addressString);
  let raw;
  if (Array.isArray(processed)) {
    raw = processed;
  } else if (processed) {
    raw = [processed];
  } else {
    raw = [];
  }
  const cleaned = raw.map((a) => (a || '').trim()).filter((a) => a.length > 0);

  const counts = {};
  return cleaned.map((addr) => {
    const slug =
      addr
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') || 'addr';
    counts[slug] = (counts[slug] || 0) + 1;
    const key =
      counts[slug] === 1
        ? `address-${slug}`
        : `address-${slug}-${counts[slug]}`;
    return { key, value: addr };
  });
};

const getAnalystOptions = (analystOptions) => {
  return sortOptions(
    analystOptions?.filter((opt) => opt?.analyst_level === -1)
  ).map((opt) => ({
    label: formatUserDisplayName(opt),
    value: opt.id,
  }));
};

const insertLineBreaks = (text, maxLength = 55) => {
  if (!text || typeof text !== 'string') {
    return text;
  }

  let result = '';
  for (let i = 0; i < text.length; i += maxLength) {
    result += text.slice(i, i + maxLength);
    if (i + maxLength < text.length) {
      result += '\n';
    }
  }
  return result;
};

const formatDate = (date) =>
  date ? moment(date).format(constants.GLOBAL_DATE_FORMAT) : 'N/A';

const buildModifiedFilters = (filters) => {
  const result = {};
  if (!filters || typeof filters !== 'object') return result;
  Object.entries(filters).forEach(([key, value]) => {
    if (key === 'verdictDateRange' && value && typeof value === 'object') {
      if (value?.start)
        result.verdictStartDate = moment(value.start).format(
          constants.GLOBAL_DATE_FORMAT
        );
      if (value?.end)
        result.verdictEndDate = moment(value.end).format(
          constants.GLOBAL_DATE_FORMAT
        );
      return;
    }
    if (key === 'initiatedDateRange' && value && typeof value === 'object') {
      if (value?.start)
        result.initiatedStartDate = moment(value.start).format(
          constants.GLOBAL_DATE_FORMAT
        );
      if (value?.end)
        result.initiatedEndDate = moment(value.end).format(
          constants.GLOBAL_DATE_FORMAT
        );
      return;
    }
    if (key === 'alerted' || key === 'alerts') {
      result[key] =
        Array.isArray(value) && value.length === 1
          ? value.join(',')
          : Array.isArray(value)
          ? ''
          : value;
    } else {
      result[key] = Array.isArray(value) ? value.join(',') : value;
    }
  });
  return result;
};

const buildBulkVerdictFilters = (filters) => {
  const result = {};
  if (!filters || typeof filters !== 'object') return result;

  Object.entries(filters).forEach(([key, value]) => {
    if (value === null || value === undefined) return;

    if (key === 'targetDateRange' && typeof value === 'object') {
      if (value.start) {
        result.target_start_date = moment(value.start).format(
          constants.GLOBAL_DATE_FORMAT
        );
      }
      if (value.end) {
        result.target_end_date = moment(value.end).format(
          constants.GLOBAL_DATE_FORMAT
        );
      }
      return;
    }

    if (key === 'initiatedDateRange' && typeof value === 'object') {
      if (value.start) {
        result.initiate_start_date = moment(value.start).format(
          constants.GLOBAL_DATE_FORMAT
        );
      }
      if (value.end) {
        result.initiate_end_date = moment(value.end).format(
          constants.GLOBAL_DATE_FORMAT
        );
      }
      return;
    }

    if (Array.isArray(value)) {
      result[key] = value.join(',');
      return;
    }

    result[key] = String(value);
  });

  return result;
};

const deepEqual = (a, b) => {
  if (a === b) return true;

  if (a === null || b === null) return false;
  if (typeof a !== 'object' || typeof b !== 'object') return false;

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA?.length !== keysB?.length) return false;

  return keysA?.every((k) => deepEqual(a?.[k], b?.[k]));
};

const arraysOfObjectsStrictEqual = (arr1, arr2) => {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;
  if (arr1?.length !== arr2?.length) return false;

  return arr1?.every((obj, i) => deepEqual(obj, arr2?.[i]));
};

export const getRatings = (ratings) => {
  return ratings?.map((rating) => rating.label);
};

export const getRatingColor = (rating) => {
  return RATING_COLORS?.[rating] ?? 'defaultColor';
};

export const getRiskRatingInitialValues = (ratings, type) => {
  const result = {};

  switch (type) {
    case 'string':
      ratings.forEach((rating) => {
        result[rating.label] = '';
      });
      return result;
    case 'array':
      ratings.forEach((rating) => {
        result[rating.label] = [];
      });
      return result;
    case 'boolean':
      ratings.forEach((rating) => {
        result[rating.label] = false;
      });
      return result;
    case 'min_max':
      ratings.forEach((rating) => {
        result[rating.label] = [{ min: 0, max: 0 }];
      });
      return result;
    default:
      return ratings;
  }
};
const getMaxValueForGraph = (data) => {
  const allValues = [];
  Object.keys(ratingsConfig).forEach((ratingKey) => {
    if (data?.[ratingKey] && Array.isArray(data[ratingKey])) {
      allValues.push(...data[ratingKey]);
    }
  });

  return allValues.length > 0 ? Math.max(...allValues) * 1.2 : 0;
};

/**
 * @description Rounds a number to the nearest integer.
 * Decimal values > 0.5 round up, values <= 0.5 round down.
 * @param {number} value - The number to round
 * @returns {number} The rounded integer
 */

const roundHalfDown = (value) => {
  return value % 1 > 0.5 ? Math.ceil(value) : Math.floor(value);
};

/**
 * @function getRiskClassificationFromValue
 * @description Get risk classification label from a risk value based on default ratings
 * @param {number} riskValue - The risk value to classify
 * @param {array} defaultRatings - Array of rating objects with min, max, and label properties
 * @returns {string} The classification label for the risk value
 */
const getRiskClassificationFromValue = (riskValue, defaultRatings) => {
  const riskRoundValue = roundHalfDown(riskValue);
  const matchingRating = defaultRatings?.find(
    (rating) => riskRoundValue >= rating.min && riskRoundValue <= rating.max
  );
  return matchingRating?.label;
};

const getFailedTypeMessage = (failedType) => {
  switch (failedType) {
    case "['Legal']":
      return 'Legal screening results could not be fetched due to a technical error.';
    case "['Corporate']":
      return 'Corporate screening results could not be fetched due to a technical error.';
    case "['Legal','Corporate']":
      return 'Legal and Corporate screening results could not be fetched due to a technical error.';
    default:
      return null;
  }
};

const trimStringValue = (value) => {
  return typeof value === 'string' ? value.trim() : value;
};

export const getSearchType = (searchData) => {
  if (searchData?.review_id) {
    return 'ongoing';
  }
  return 'initial';
};
export const buildTrueMatchFlags = (value) => {
  const options = Constants.CommonConst.TRUE_MATCH_OPTIONS; // adjust to your actual import
  const vals = Array.isArray(value)
    ? value.map((v) => String(v).toLowerCase())
    : [];
  return Object.fromEntries(
    options.map((opt) => {
      const key = String(opt);
      const match = vals.includes(key.toLowerCase());
      return [key, match ? true : 'none'];
    })
  );
};
export const otherFieldsPositions = (screenType) =>
  screenType === 'ongoing' ? 11 : 12;

/**
 * @function getKeyedList
 * @description Maps a plain array of primitive values into { value, uniqueKey } pairs
 * so lists can be rendered with a stable, collision-safe React key derived from the
 * value and its position, instead of relying on the array index alone as the key
 * @param {Array} list - array of primitive values (strings/numbers)
 * @returns {Array<{value: *, uniqueKey: string}>}
 * @example getKeyedList(['a', 'b']) // [{ value: 'a', uniqueKey: 'a_0' }, { value: 'b', uniqueKey: 'b_1' }]
 */
export const getKeyedList = (list = []) =>
  list.map((value, index) => ({ value, uniqueKey: `${value}_${index}` }));

/**
 * @function pollUploadStatus
 * @description Polls by calling fetchData until the upload is completed
 * @param {Function} fetchData - Function to fetch data and check upload status
 * @param {string} uploadId - The upload ID to check for completion
 * @param {string|null} admin - Optional admin/manager ID
 * @param {number} maxRetries - Maximum number of polling attempts (default: 60)
 * @param {number} pollInterval - Interval between polls in milliseconds (default: 1000)
 * @returns {Promise<void>}
 */
const pollUploadStatus = async (
  fetchData,
  uploadId,
  admin,
  maxRetries = 5,
  pollInterval = 1000
) => {
  let retries = 0;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    if (retries >= maxRetries) {
      SwalToast({
        icon: 'error',
        title:
          'Upload is taking longer than expected. Please check back later.',
      });
      return;
    }
    // eslint-disable-next-line no-await-in-loop
    const response = await fetchData(admin, uploadId);
    if (response?.data?.[uploadId] === 'completed') {
      return;
    }
    // eslint-disable-next-line no-await-in-loop
    await new Promise((resolve) => setTimeout(resolve, pollInterval));
    retries += 1;
  }
};

/**
 * @function handleConfigurationUpload
 * @description Generic handler for uploading configuration files across different parameter types
 * @param {Object} params - Configuration object
 * @param {*} params.fileData - The file data to upload
 * @param {Function} params.startUpload - Function to initiate upload (startBulkUpload or startFileUpload)
 * @param {Function} params.importFile - Function to import the uploaded file
 * @param {Function} params.setFileData - State setter for file data
 * @param {Function} params.setUploadStarted - State setter for upload started flag
 * @param {Function} params.fetchData - Function to fetch updated data after upload
 * @param {string} params.parameterName - Name of the parameter being uploaded
 * @param {string|null} params.admin - Optional admin/manager ID
 * @returns {Promise<void>}
 */
export const handleConfigurationUpload = async ({
  fileData,
  startUpload,
  importFile,
  setFileData,
  setUploadStarted,
  fetchData,
  parameterName,
  admin = null,
}) => {
  if (fileData !== null) {
    setUploadStarted(true);
    await startUpload(
      fileData,
      () => {},
      async (res) => {
        const uploadId = res?.data?.upload_id;
        await importFile({
          parameter_name: parameterName,
          upload_id: uploadId,
          ...(admin && { manager_id: admin }),
        });
        await pollUploadStatus(fetchData, uploadId, admin);
        setFileData(null);
        setUploadStarted(false);
      },
      () => setUploadStarted(false)
    );
  }
};

/**
 * @function processTagInput
 * @description Processes input value for tags, splitting by separator if enabled
 * @param {string} value - The input string
 * @param {Array} currentTags - Current list of tags
 * @param {string} separator - Separator to split by (default: ',')
 * @returns {object} { newTags, remainingInput }
 */
export const processTagInput = (value, currentTags, separator = ',') => {
  if (!value) return { newTags: currentTags, remainingInput: '' };

  const newWords = value.split(separator);

  if (value.endsWith(separator)) {
    newWords.pop();
    const words = [
      ...currentTags,
      ...newWords.filter((val) => val.trim() !== ''),
    ];
    return { newTags: words, remainingInput: '' };
  }

  if (newWords.length > 1) {
    const remaining = newWords.pop();
    const words = [
      ...currentTags,
      ...newWords.filter((val) => val.trim() !== ''),
    ];
    return { newTags: words, remainingInput: remaining };
  }

  return { newTags: currentTags, remainingInput: value };
};

const hasValidStatus = (list) => {
  if (!Array.isArray(list) || list.length === 0) return true;
  return list.every(
    (item) => item?.status === 'selected' || item?.status === 'notSelected'
  );
};

/** @function getUserRoleLabel
 * @description Helper to get a properly formatted user role label for display
 * @param {object} data - User data object
 * @returns {string} Formatted role label (e.g., 'Manager', 'Maker', 'User')
 */
const getUserRoleLabel = (data) => {
  const rawRole = data?.role || data?.user_role || data?.userType || 'User';
  return rawRole.charAt(0).toUpperCase() + rawRole.slice(1);
};

/**
 * @function getTaxonomyOptions
 * @description Generates options for taxonomy MultiSelect with a 'Select All' option.
 * @param {Array} taxonomyData - Array of taxonomy objects with labels.
 * @returns {Array} Array of options for MultiSelect.
 */
export const getTaxonomyOptions = (taxonomyData) => [
  constants.SELECT_ALL_OPTION,
  ...(taxonomyData?.length
    ? taxonomyData.map((data) => ({
        ...data,
        value: data.label,
        label: data.label,
      }))
    : []),
];

const resetDependentFilters = (prevFilters, dependentKeys, resetValue = []) => {
  const updates = dependentKeys
    .filter((key) => key in prevFilters)
    .reduce(
      (acc, key) => ({
        ...acc,
        [key]: Array.isArray(resetValue) ? [...resetValue] : resetValue,
      }),
      {}
    );

  if (Object.keys(updates).length === 0) return prevFilters;

  return { ...prevFilters, ...updates };
};
// Merge base column defs (with Cell, etc.) and saved config (selected, width, etc.)
const mergeColumnsWithConfig = (baseCols, savedCols) => {
  if (!savedCols?.length) return baseCols;
  const savedByKey = savedCols.reduce((acc, col) => {
    const key = col.id || col.accessor;
    if (key) acc[key] = col;
    return acc;
  }, {});
  return baseCols.map((col) => {
    const key = col.id || col.accessor;
    const saved = savedByKey[key];
    if (!saved) return col;

    return {
      ...col,
      selected:
        typeof saved.selected === 'boolean' ? saved.selected : col.selected,
      width: saved.width ?? col.width,
    };
  });
};

/**
 * @function dedupeArrayByKey
 * @description Returns a new array with duplicate items (by key) removed.
 * @param {Array} array - The array to dedupe
 * @param {Function} getKey - Function that receives an item and returns its key
 * @returns {Array} New array with unique items by key
 */
const dedupeArrayByKey = (array = [], getKey) => {
  const seen = new Set();
  return array.filter((item) => {
    const key = getKey(item);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

const getUniqueAnalysts = (teams = []) => {
  const allAnalysts = teams.flatMap((team) => team?.analysts || []);
  const withId = allAnalysts.filter((a) => a?.id);
  // use the existing dedupe helper
  return dedupeArrayByKey(withId, (analyst) => analyst.id);
};

const validateFileColumnsForISO = (fileColumns, columns) => {
  const incrementalPatterns = {
    IntrmyAgt_BICFI: /^IntrmyAgt\d+\/FinInstnId\/BICFI$/,
    IntrmyAgt_Nm: /^IntrmyAgt\d+\/FinInstnId\/Nm$/,
  };

  const getPatternKey = (col) => {
    for (const [key, pattern] of Object.entries(incrementalPatterns)) {
      if (pattern.test(col)) {
        return key;
      }
    }
    return null;
  };

  // Create a map of expected columns with their indices (excluding incremental fields)
  const expectedStaticColumns = [];
  const expectedIncrementalByPattern = {};

  columns.forEach((col, idx) => {
    const patternKey = getPatternKey(col);
    if (patternKey) {
      if (!expectedIncrementalByPattern[patternKey]) {
        expectedIncrementalByPattern[patternKey] = [];
      }
      expectedIncrementalByPattern[patternKey].push(idx);
    } else {
      expectedStaticColumns.push({ col, idx });
    }
  });

  // Create a map of file columns
  const fileStaticColumns = [];
  const fileIncrementalByPattern = {};

  fileColumns.forEach((col, idx) => {
    const patternKey = getPatternKey(col);
    if (patternKey) {
      if (!fileIncrementalByPattern[patternKey]) {
        fileIncrementalByPattern[patternKey] = [];
      }
      fileIncrementalByPattern[patternKey].push(idx);
    } else {
      fileStaticColumns.push({ col, idx });
    }
  });

  // Validate that all static columns from expected are present in file columns
  if (expectedStaticColumns.length !== fileStaticColumns.length) {
    return false;
  }

  for (let i = 0; i < expectedStaticColumns.length; i++) {
    if (expectedStaticColumns[i].col !== fileStaticColumns[i].col) {
      return false;
    }
  }

  // Validate that incremental patterns exist in both (but counts can differ)
  for (const patternKey of Object.keys(expectedIncrementalByPattern)) {
    if (!fileIncrementalByPattern[patternKey]) {
      return false;
    }
  }

  return true;
};

// returns the key for party details based on the party type (e.g., 'payer_details' for 'payer')
const getPartyDetails = (data, partyType) => {
  const possibleKeys = PARTY_MAPPINGS[partyType] || [];

  for (const key of possibleKeys) {
    if (data?.[key]) {
      return key;
    }
  }

  return null;
};

// returns all fields ending with '_details'
const getDetailsFieldNames = (data) => {
  if (!data || typeof data !== 'object') {
    return [];
  }

  return Object.keys(data).filter((key) => key.endsWith('_details'));
};

const getRefForIndex = (party, partyOccurrences, componentRefs) => {
  // Find which party this index belongs to
  for (const [partyName, occurrence] of Object.entries(partyOccurrences)) {
    if (occurrence.field === party) {
      if (!componentRefs.current[partyName]) {
        componentRefs.current[partyName] = React.createRef();
      }
      return componentRefs.current[partyName];
    }
  }
  return null;
};

const hasObjectValues = (obj) =>
  obj && Object.values(obj).some((val) => !isValueEmpty(val));

// for merging sanctions results into one single array from diff entities
const mergeResults = (data, resultKey, alertKey) =>
  Object.entries(data).flatMap(([partyType, uuidMap]) =>
    Object.entries(uuidMap).flatMap(([uuid, value]) =>
      (value[resultKey] || []).map((item) => ({
        ...item,
        resultType: alertKey,
        [`card_${uuid}`]: true,
        party: partyType,
      }))
    )
  );

// for pep ams corporate legal
const mergeAllDetails = (data) => {
  return Object.entries(data).flatMap(([partyType, uuidMap]) =>
    Object.entries(uuidMap).flatMap(([uuid, matchArray]) =>
      matchArray.map((item) => ({
        ...item,
        [`card_${uuid}`]: true,
        party: partyType,
      }))
    )
  );
};

const sortByParty = (alertList) => {
  return alertList.sort((a, b) => {
    const partyA = a?.party ?? '';
    const partyB = b?.party ?? '';
    return partyA.localeCompare(partyB);
  });
};

const mergeByField = (data, partyKeys, field, resultType) => {
  const merged = partyKeys.flatMap((partyKey) => {
    const partyObj = data?.[partyKey] || {};

    return Object.values(partyObj).flatMap((entity) => {
      const list = entity?.result?.[field];
      if (!Array.isArray(list)) return [];

      return list.map((item) => ({
        ...item,
        party: partyKey,
        resultType,
      }));
    });
  });

  return sortByParty(merged);
};

const getSafeValue = (data, field) => {
  if (!data) return undefined;
  return Object.values(data ?? {})?.[0]?.[field];
};

const getActiveAlertsFields = (data, isUuidNested = false) => {
  const alerts = new Set();
  const detailsFieldNames = getDetailsFieldNames(data);

  for (const field of detailsFieldNames) {
    const fieldData = data?.[field];
    if (!fieldData) continue;

    for (const alertType of constants.alertListTypes) {
      const label = constants.ALERT_TYPE_LABELS[alertType];
      if (!label) continue;

      if (isUuidNested) {
        // data?.[field]?.[uuid]?.[alertType]
        for (const nestedValue of Object.values(fieldData)) {
          if (nestedValue?.[alertType] > 0) {
            alerts.add(label);
            break;
          }
        }
      } else {
        // data?.[field]?.[alertType]
        if (fieldData[alertType] > 0) {
          alerts.add(label);
        }
      }
    }
  }

  return alerts.size > 0 ? [...alerts].join(', ') : 'No Alerts';
};

const hasAlerts = (field, alertType, data) => {
  const fieldData = data?.[field];
  if (!fieldData) return false;

  return Object.values(fieldData).some((item) => item?.[alertType] > 0);
};

const getSanctionsList = (searchType) => {
  switch (searchType) {
    case SEARCH_TYPES.i.key:
    case SEARCH_TYPES.b.key:
      return HISTORY_SANCTIONS_TABLE_DATA.INDIVIDUAL;
    case SEARCH_TYPES.e.key:
      return HISTORY_SANCTIONS_TABLE_DATA.ENTITY;
    case SEARCH_TYPES.a.key:
      return HISTORY_SANCTIONS_TABLE_DATA.AIRCRAFT;
    case SEARCH_TYPES.v.key:
      return HISTORY_SANCTIONS_TABLE_DATA.VESSEL;
    default:
      return [];
  }
};
const isNameField = (field) =>
  [field?.backend_name, field?.display_name]
    .filter(Boolean)
    .some((value) => Regex.nameFieldReg.test(value));

const getFieldsWithNamesFirst = (fields = []) =>
  fields
    .map((field, fieldIndex) => ({ field, fieldIndex }))
    .sort(
      (first, second) =>
        Number(isNameField(second.field)) - Number(isNameField(first.field))
    );

export const CoreUtils = {
  readExcelFile,
  sortByParty,
  hasAlerts,
  getRefForIndex,
  getActiveAlertsFields,
  validateFileColumnsForISO,
  isValueEmpty,
  initKeycloak,
  getErrorHelperText,
  pdfDownloadHandler,
  getJsonDownloadUrl,
  downloadFile,
  summaryTableDataMapper,
  prepareCsvDataOfDownloads,
  autoScroll,
  autoScrollToComponent,
  createRowData,
  createColumnNamesRow,
  validateFileColumns,
  alertListType,
  alertBySanctions,
  validateInitiateFileColumns,
  customAxiosForFastApi,
  downloadExcelFile,
  capitalizeFirstLetter,
  downloadBulkInitiateExcelFile,
  sortOptions,
  capitalizeFirstLetterOfWords,
  joinArrayWithSeparator,
  formatDisplayValue,
  calculatePasswordStrength,
  getReworkDataForRow,
  getReferralDataForRow,
  sortByDate,
  formatUserDisplayName,
  excelDateToJSDate,
  formatSnakeCaseToTitleCase,
  convertArrayParamsToString,
  getTransferDataForRow,
  splitTransferAndReassignData,
  mergeArrays,
  getFieldError,
  CalculateCount,
  getDisplayValue,
  getCustomFieldsWithValue,
  generateDynamicSchema,
  isParameterRequired,
  processAddressData,
  restructureAddressData,
  getDedupeTypeKey,
  getAnalystOptions,
  insertLineBreaks,
  formatDate,
  buildModifiedFilters,
  buildBulkVerdictFilters,
  arraysOfObjectsStrictEqual,
  getMaxValueForGraph,
  getRiskClassificationFromValue,
  getFailedTypeMessage,
  getDetailType,
  trimStringValue,
  getSearchType,
  buildTrueMatchFlags,
  processTagInput,
  hasValidStatus,
  getAlertListTypesForTable,
  getAlertListTypesForTransactionDetails,
  getUserRoleLabel,
  resetDependentFilters,
  dedupeArrayByKey,
  getUniqueAnalysts,
  getPartyDetails,
  getDetailsFieldNames,
  hasObjectValues,
  mergeResults,
  mergeAllDetails,
  mergeByField,
  getSafeValue,
  mergeColumnsWithConfig,
  lastElement,
  castNumeric,
  castFieldValueByType,
  getSanctionsList,
  getKeyedList,
  sortSelectedFirst,
  isNameField,
  getFieldsWithNamesFirst,
};

